import { RadioGroupOptions } from 'mymoria-ui/components/Form/RadioGroup';
import { global as t } from 'data';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { TrustedPerson } from 'mymoria-types';
import { Card, Col, Heading, Markdown, Row } from 'mymoria-ui/components';
import { InputField, RadioGroupField, TextareaField, EmailField, SelectField } from 'forms/fields';
import config from 'config';

const saluteTypes: RadioGroupOptions[] = [
  { value: 'sir', label: t.forms.salutation.sir },
  { value: 'madame', label: t.forms.salutation.madame },
];

const TrustedPersonForm: FunctionComponent = () => {
  const [emailDirty, setEmailDirty] = useState(false);
  const { values, initialValues } = useFormikContext<TrustedPerson>();

  useEffect(() => {
    if (values.email !== initialValues.email) {
      setEmailDirty(true);
    } else {
      setEmailDirty(false);
    }
  }, [values.email, initialValues.email]);

  return (
    <Card
      title={t.trustedPerson.personalInfo.title}
      caption={t.trustedPerson.personalInfo.caption}
      hint={t.trustedPerson.personalInfo.hint}
    >
      <Row flexWrap="wrap" mx={-1}>
        <Col width={1}>
          <RadioGroupField name="salutation" values={saluteTypes} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="firstname" label={t.forms.firstname} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="lastname" label={t.forms.lastname} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <SelectField
            name="relationship"
            label={t.forms.relationship}
            options={config.trustedPersonRelationships}
          />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="street" label={t.forms.street} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="postalCode" label={t.forms.postalCode} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="city" label={t.forms.city} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <EmailField name="email" label={t.forms.email} />
        </Col>
        <Col width={[1, 1, 1 / 2]}>
          <InputField name="phone" label={t.forms.phone} />
        </Col>
        <Col width={1}>
          <TextareaField name="note" label={t.forms.note} />
        </Col>
        {emailDirty && (
          <Col width={1} mt="2rem">
            <Heading.Heading2>{t.trustedPerson.permission.title}</Heading.Heading2>
            <Markdown source={t.trustedPerson.permission.caption} />
          </Col>
        )}
      </Row>
    </Card>
  );
};

export default TrustedPersonForm;
